import React from "react";
import BaseComponent from './baseComponent'
import ResetComponent from './ResetComponent'
import Utils, {dispatchAction} from "../../utility";
import {UserService} from "../../services";
import auth0 from 'auth0-js';
import {eventConstants} from "../../constants"
import { connect } from "react-redux";
import {actionTypeConstant, cookiesConstants, genericConstants, userRoles} from "../../constants/index";
import {history} from "../../managers/history";
import toast, { Toaster } from "react-hot-toast";
import CommonToasts from "../../common/components/commonToast";




class Reset extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            emailError: "",
            newEmailError:"",
        }
    }

    componentDidMount() {

    }

    onChangeEvent = (event) => {
        this.setState({[event.target.id]: event.target.value});
    };
    routeChange = () => {
        history.push('login');
      }
    // togglePassword = (event) => {
    //     this.setState({isPasswordVisible: !this.state.isPasswordVisible});
    // };


    validateResetform = () => {
        this.setState({
            emailError: Utils.validateEmail(this.state.email) ? "" : "Invalid email address",
            // passwordError: Utils.isPasswordValid(this.state.password) ? "" : "Password should contain 1 special character"
        });
         return( Utils.validateEmail(this.state.email) 
         );
    };
    onResetClicked = async (event) =>{
        event.preventDefault();
        // (this.validateResetform())
        if (!this.validateResetform()) {
            // Utils.apiFailureToast(genericConstants.INVALID_EMAIL);
            this.setState({
                emailError:  "Email is not valid",
                // passwordError: Utils.isPasswordValid(this.state.password) ? "" : "Password should contain 1 special character"
            });
            return;
          } 
        const req= {
            email : this.state.email
        }
        this.props.dispatchAction(eventConstants.SHOW_LOADER)
        const[error , response] =await Utils.parseResponse(UserService.forgotPassword(req))
        this.props.dispatchAction(eventConstants.HIDE_LOADER)
        if(!response || error){
        // Utils.apiFailureToast("Too Many Requests");
        this.setState({
            newEmailError: "Too Many Requests",
            // passwordError: Utils.isPasswordValid(this.state.password) ? "" : "Password should contain 1 special character"
        });
        return;
        }
        CommonToasts.successfullySent("Email Sent!!");
        // Utils.apiSuccessToast("Email Sent!!")
        // history.push('resetpassword')
    }


    // onResetClicked = (event) => {
    //     event.preventDefault();
    //     if (this.validateResetform())            
    //         Utils.basicAlert("A password recovery code has been sent to your registered email ID.")
    // };

    render() {
        return (
            <>
            <div>
          <Toaster />
        </div>
            <ResetComponent state={this.state}
                            onChangeEvent={this.onChangeEvent}
                            togglePassword={this.togglePassword}
                            forgotPassword={this.forgotPassword}
                            onResetClicked={this.onResetClicked}
                            routeChange={this.routeChange}/>
                            </>
        );
    }
}
const mapStateToProps = (state) => {
    return { user: state.user };
  };
export default connect(mapStateToProps,{dispatchAction})(Reset);